// sso-login page
import { useEffect } from "react";

export default function SSOLogin() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token && typeof window !== "undefined") {
      try {
        localStorage.setItem("token", token);
        // Optionally clear search params after storing token
        window.location.replace("/");
      } catch (error) {
        // storage is unavailable, fallback to login
        window.location.replace("/login");
      }
    } else {
      window.location.replace("/login");
    }
  }, []);

  return <p>Logging you in...</p>;
}